import { z } from "zod";

export const REPO_TOOL_KIND_VALUES = [
  "quality",
  "build",
  "test",
  "run",
] as const;

export const repoToolKindSchema = z.enum(REPO_TOOL_KIND_VALUES);
export type RepoToolKind = z.infer<typeof repoToolKindSchema>;

export const REPO_TOOL_STATUS_VALUES = ["error", "warning", "valid"] as const;

export const repoToolStatusSchema = z.enum(REPO_TOOL_STATUS_VALUES);
export type RepoToolStatus = z.infer<typeof repoToolStatusSchema>;
